import { createFileRoute } from '@tanstack/react-router';
import { JobMaterialsPage } from '@/features/inventory/JobMaterialsPage';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/jobs/$jobId')({
  component: Page,
});
function Page() {
  const { jobId } = Route.useParams();
  return <JobMaterialsPage key={jobId} jobId={jobId} />;
}
